import fetch from "@lib/fetch";
import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { audienceSyncAllotmentsCacheKey } from "./constants";

export const getAudienceSyncAllotments = reactQueryFetcherAdapter(
  audienceSyncAllotmentsCacheKey,
  async (signal, companyId: string): Promise<string[]> => {
    return fetch(`/companies/${companyId}/audience_sync_allotments`, "GET", undefined, { signal });
  }
);
